var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "部门信息" },
      model: {
        value: _vm.departmentFormShow,
        callback: function ($$v) {
          _vm.departmentFormShow = $$v
        },
        expression: "departmentFormShow",
      },
    },
    [
      _c(
        "Form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "部门名称" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.departmentForm.departmentName,
                          callback: function ($$v) {
                            _vm.$set(_vm.departmentForm, "departmentName", $$v)
                          },
                          expression: "departmentForm.departmentName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "联系人" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.departmentForm.departmentContact,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.departmentForm,
                              "departmentContact",
                              $$v
                            )
                          },
                          expression: "departmentForm.departmentContact",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "手机" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.departmentForm.departmentPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.departmentForm, "departmentPhone", $$v)
                          },
                          expression: "departmentForm.departmentPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "类型" } },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.departmentForm.departmentType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.departmentForm,
                                "departmentType",
                                $$v
                              )
                            },
                            expression: "departmentForm.departmentType",
                          },
                        },
                        [
                          _c(
                            "Option",
                            { attrs: { value: _vm.DEPARTMENT_TYPE_BINFEN } },
                            [_vm._v(_vm._s(_vm.DEPARTMENT_TYPE_BINFEN))]
                          ),
                          _c(
                            "Option",
                            { attrs: { value: _vm.DEPARTMENT_TYPE_EXTERNAL } },
                            [_vm._v(_vm._s(_vm.DEPARTMENT_TYPE_EXTERNAL))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value: _vm.departmentForm.departmentStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.departmentForm,
                                "departmentStatus",
                                $$v
                              )
                            },
                            expression: "departmentForm.departmentStatus",
                          },
                        },
                        _vm._l(_vm.statusOptions, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "公司" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.departmentForm.companyUuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.departmentForm, "companyUuid", $$v)
                            },
                            expression: "departmentForm.companyUuid",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            {
              staticClass: "form-button",
              attrs: { type: "success" },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存")]
          ),
          _c(
            "Button",
            {
              staticClass: "form-button",
              attrs: { type: "text" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }